import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

interface hookMember {
  installReportId: number;
  setInstallReportId: any;
  mediaList: any;
  setMediaList: any;
  mediaId: number;
  setMediaId: any;
  mediaName: string;
  setMediaName: any;
  comment: string;
  setComment: any;
  images: File[];
  setImages: any;
  videos: File[];
  setVideos: any;
  workDate: Date;
  setWorkDate: any;

  errorMessage: any;

  updateDemolishData: () => void;
}

const useDemolishUpdate = (): hookMember => {
  const params = useParams();
  const navigate = useNavigate();

  const [installReportId, setInstallReportId] = useState<number>(0);
  const [mediaList, setMediaList] = useState([]);
  const [mediaId, setMediaId] = useState<number>(0);
  const [mediaName, setMediaName] = useState<string>("");
  const [comment, setComment] = useState<string>("");
  const [images, setImages] = useState<File[]>([]);
  const [videos, setVideos] = useState<File[]>([]);
  const [workDate, setWorkDate] = useState<Date>(new Date());

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (params.installReportId) {
          const response = await fetch(
            `${process.env.REACT_APP_URL}/install-report/update-one?id=${params.installReportId}`
          );
          const jsonData = await response.json();
          const mediaListResponse = await fetch(
            `${process.env.REACT_APP_URL}/media/all`
          );
          const mediaListData = await mediaListResponse.json();

          setMediaList(mediaListData);

          const {
            installReportId,
            mediaId,
            comment,
            workDate,
          } = jsonData.data;

          setInstallReportId(installReportId);
          setMediaId(mediaId);
          setComment(comment);
          setMediaName(jsonData.data.media.name);
          setWorkDate(workDate);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [params.installreportId]);

  const updateDemolishData = async () => {
    const result = {
      installReportId,
      mediaId,
      comment,
      workDate,
    };

    if (!mediaId) {
      setErrorMessage("필수 값이 입력되지 않아 저장되지 않았습니다.");
    } else {
      const commonBody = {
        installReportId,
        mediaId,
        category: "demolish",
        comment,
        workDate
      };

      const imageFormData = new FormData();
      imageFormData.append("mediaId", mediaId.toString());
      imageFormData.append("category", "demolish");
      imageFormData.append("type", "images");
      images.forEach((image) => {
        imageFormData.append('files', image);
      });

      const videoFormData = new FormData();
      videoFormData.append("mediaId", mediaId.toString());
      videoFormData.append("category", "demolish");
      videoFormData.append("type", "videos");
      videos.forEach((video) => {
        videoFormData.append('files', video);
      });

      const response = await fetch(
        `${process.env.REACT_APP_URL}/install-report/update-demolish`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(commonBody),
        }
      );

      if (!response.ok) {
        throw new Error('Failed to create actual image');
      }

      const imageResponse = await fetch(
        `${process.env.REACT_APP_URL}/install-report/upload-files`,
        {
          method: "POST",
          body: imageFormData,
        }
      );

      if (!imageResponse.ok) {
        throw new Error('Failed to upload images');
      }

      const videoResponse = await fetch(
        `${process.env.REACT_APP_URL}/install-report/upload-files`,
        {
          method: "POST",
          body: videoFormData,
        }
      );

      if (!videoResponse.ok) {
        throw new Error('Failed to upload videos');
      }

      navigate("/installReport/installReportList");

    }
  };

  return {
    installReportId,
    setInstallReportId,
    mediaList,
    setMediaList,
    mediaId,
    setMediaId,
    mediaName,
    setMediaName,
    comment,
    setComment,
    updateDemolishData,
    images,
    setImages,
    videos,
    setVideos,
    workDate,
    setWorkDate,
    errorMessage,
  };
};

export default useDemolishUpdate;
